<template>
  <div aria-label="Pagination">
    <ul class="pagination">
      <li class="page-item" :class="{disabled: currentPage===0}" @click="showPrev">
        <a class="page-link" href="#">
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">Previous</span>
        </a>
      </li>
      <li class="page-item" :class="{active: currentPage===pageNo}" @click="showPage(pageNo)" v-for="pageNo in pages" :key="pageNo">
        <a class="page-link" href="#" >
          {{ pageNo + 1}}
        </a>
      </li>
      <li class="page-item" :class="{disabled: currentPage + 1 >= totalPages}" @click="showNext">
        <a class="page-link" href="#">
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">Next</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    pagination: Object
  },
  data () {
    return {
    }
  },
  computed: {
    // 現在ページ
    currentPage: function () {
      return this.pagination.currentPage
    },
    // トータルページ数
    totalPages: function () {
      return this.pagination.totalPages
    },
    // 最大表示ページ数
    dispMaxPageSize: function () {
      return this.pagination.dispMaxPageSize
    },
    // 画面表示するページ番号
    pages: function () {
      let start
      let last
      if (this.isLeftOmittable && this.isRightOmittable) {
        // 現在ページを中央に、ページ表示数分展開
        start = this.currentPage - Math.floor(this.dispMaxPageSize / 2)
        last = start + this.dispMaxPageSize
      } else if (this.isLeftOmittable) {
        // 始端のみ省略中の場合。終端をトータルページからページ表示数分表示。
        start = this.totalPages - this.dispMaxPageSize
        last = this.totalPages
      } else {
        // それ以外。１〜最大ページ表示数 or 1〜トータルページ
        start = 0
        last = this.totalPages < this.dispMaxPageSize ? this.totalPages : this.dispMaxPageSize
      }
      return Array.apply(null, {length: last}).map(Number.call, Number).slice(start, last)
    },
    // 始端側ページの省略判定
    isLeftOmittable: function () {
      // トータルページ数が最大表示ページ数より少ない場合は、省略させない
      if (this.totalPages <= this.dispMaxPageSize) {
        return false
      }
      return this.currentPage + 1 - Math.floor(this.dispMaxPageSize / 2) > 1
    },
    // 終端側ページの省略判定
    isRightOmittable: function () {
      // トータルページ数が最大表示ページ数より少ない場合は、省略させない
      if (this.totalPages <= this.dispMaxPageSize) {
        return false
      }
      return this.currentPage + 1 + Math.floor(this.dispMaxPageSize / 2) < this.totalPages
    }
  },
  methods: {
    // 先頭ページ
    showFirst () {
      this.pagination.currentPage = 0
    },
    // 前ページ
    showPrev () {
      if (this.currentPage > 0) {
        this.pagination.currentPage--
      }
    },
    // 次ページ
    showNext () {
      if (this.currentPage + 1 < this.totalPages) {
        this.pagination.currentPage++
      }
    },
    // 最終ページ
    showLast () {
      this.pagination.currentPage = this.totalPages - 1
    },
    // ページ指定
    showPage (index) {
      this.pagination.currentPage = index
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/assets/js/components/Pagination.vue